import { useState } from "react";
import Button from "react-bootstrap/Button";
function ShareBlock({ url, text, configuration, objectId }) {
  
  const content_type = configuration.content_type;
  const object_id = objectId || configuration.object_id;

  const shareFacebook = `${configuration.shareUrl}?url=${window.location.protocol}//${window.location.hostname}${url}&text=${text}&type=facebook&content_type=${content_type}&object_id=${object_id}`;
  const shareTwitter = `${configuration.shareUrl}?url=${window.location.protocol}//${window.location.hostname}${url}&text=${text}&type=twitter&content_type=${content_type}&object_id=${object_id}`;
  const shareWhatsApp = `${configuration.shareUrl}?url=${window.location.protocol}//${window.location.hostname}${url}&text=${text}&type=whatsapp&content_type=${content_type}&object_id=${object_id}`;
  const shareTelegram = `${configuration.shareUrl}?url=${window.location.protocol}//${window.location.hostname}${url}&text=${text}&type=telegram&content_type=${content_type}&object_id=${object_id}`;
  const shareEmail = `mailto:?subject=${text}&body=${window.location.protocol}//${window.location.hostname}${url}`;

  const isMobile = window.navigator.userAgent.search("Mobile") >= 0;

  return (
    <div className="w-100 d-flex align-items-center justify-content-center">
        <div className="w-auto text-center gap-2 d-flex align-items-center justify-content-center flex-wrap">
          <a
            href={shareFacebook}
            target="_blank"
            rel="noreferrer"
            title="Facebook"
          >
            <i className="fa-brands fa-facebook fs-2" />
          </a>

          <a href={shareTwitter} target="_blank" rel="noreferrer" title="X">
            <i className="fa-brands fa-x-twitter fs-2" />
          </a>

          {isMobile && (
            <a
              href={shareWhatsApp}
              target="_blank"
              rel="noreferrer"
              title="WhatsApp"
            >
              <i className="fa-brands fa-whatsapp fs-2" />
            </a>
          )}

          <a
            href={shareTelegram}
            target="_blank"
            rel="noreferrer"
            title="Telegram"
          >
            <i className="fa-brands fa-telegram fs-2" />
          </a>

          <a href={shareEmail} target="_blank" rel="noreferrer" title="Email">
            <i className="fa-regular fa-envelope fs-2" />
          </a>
        </div>
    </div>
  );
}

export default ShareBlock;
